/// \file breadcrumbs.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import { Fragment } from "react";
import { useMatches, useNavigate, useSubmit } from "react-router-dom";
import localDBCalls from "../services/localDBCalls";

export interface BreadCrumbModel {
  pathname?: string,
  action?: string,
  id?: string,
  text: string
}

const Breadcrumbs: React.FC = () => {
  const navigate = useNavigate();
  const matches = useMatches();
  const submit = useSubmit();

  const crumbs = matches
    // first get rid of any matches that don't have handle and crumb
    .filter((match) => {
      if(match.handle) {
        const bc = match.handle as BreadCrumbModel;
        if(bc) {
          return true;
        }
      }
      return false;
    } )
    // now map them into an array of elements, passing the loader
    // data to each one
    .map<BreadCrumbModel>((match) => {
      if(match.handle) {
        const bc = match.handle as BreadCrumbModel;
        let bcText = bc.text;
        if(bcText=="inherit"){
          if(match.pathname){
            bcText=match.pathname.split("/").slice(-1)[0];
          }
        }
        return {
          id: bc.id ?? match.id,
          text: bcText,
          action: bc.action ?? undefined,
          pathname: bc.pathname ?? match.pathname
        };
      }
      return {id: '-1', text: 'No Crumb', pathname: ''};
    });
    let moreCustomers = true;
    while(moreCustomers){
      const testCrumb = crumbs[0];
      if(testCrumb && testCrumb?.action && testCrumb.id){
        crumbs.shift();
      }
      else{
        moreCustomers = false;
      }
    }
    const strCustomerCrumbs = localStorage.getItem('customer-crumbs');
    //in the format [{parent},{child},{grandchild}]
      //each member: {id:customer_id,text:name,action:customer}
  
    if(strCustomerCrumbs) {
      const customerCrumbs = JSON.parse(strCustomerCrumbs) as BreadCrumbModel[];
      if(customerCrumbs && crumbs) {
        try{
          crumbs.splice(0,1,...customerCrumbs);
        }
        catch(e){
          console.error("WARNING: crumbs splice failed: ", e)
        }
      }
    }

    //if no breadcrumb, we can add the home breadcrumb
    if(crumbs.length==0){
      crumbs.push({text:"Home", pathname:"/", id:"-1"})
    }

  const handleBreadcrumbItemSelect = async(event: any, crumb:BreadCrumbModel) => {
    const validToken = await localDBCalls.checkUserIsValid();
    const selectedCrumb: BreadCrumbModel | undefined = crumb;
    //If action exits then perform it, otherwise navigate to pathname
    if(selectedCrumb?.action && selectedCrumb.id) {
      //if action, it is a customer breadcrumb and we need to change customer path/level
      const customerCrumbs = localStorage.getItem('customer-crumbs');
      if(customerCrumbs){
        const customerCrumbArray = JSON.parse(customerCrumbs);
        for(let i=0;i<customerCrumbArray.length;i++){
          if(customerCrumbArray[i].id==selectedCrumb.id){
            const setCustomerCrumb = JSON.stringify(customerCrumbArray.slice(0,i+1));
            localStorage.setItem('customer-crumbs',setCustomerCrumb);
            localStorage.setItem("customer_id",selectedCrumb.id);
            localDBCalls.changeCustomer("/user/changeCustomer",document.cookie,selectedCrumb.id)
          }
        }
      }
      if(validToken==1){
        navigate("/"); //redirect to home page
      }
      else{
        navigate("/auth/signin");
      }
    }else if(selectedCrumb?.pathname) {
      //else it is a page redirect
      if(validToken==1){
        navigate(selectedCrumb.pathname);
      }
      else{
        navigate("/auth/signin");
      }
    } 
  };

  return (
    <Fragment>
      <style>{`
        .k-breadcrumb-link {
          color: #0d6efd;
        }
      `}</style>
      <ol className="breadcrumbTopper">
        {crumbs.map((crumb:BreadCrumbModel, index:number) => <ul key={"breadcrumbUL"+index.toString()} className="breadcrumbItem">{index!=0 ? <Fragment><span key={"breadcrumbSpacer"+index.toString()} className="breadcrumbSpacer">{">"}</span><button className="breadcrumbTextItem" onClick={(event:any)=>handleBreadcrumbItemSelect(event,crumb)}>{crumb.text}</button></Fragment> : <button className="breadcrumbTextItem" onClick={(event:any)=>handleBreadcrumbItemSelect(event,crumb)}>{crumb.text}</button>}</ul>)}
      </ol>
    </Fragment>
  );
}

export default Breadcrumbs;